import React from "react";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

const Dob = ({
  field,
  name,
  onChange,
  errorMessage = "*Please enter a valid date"
}) => {

  const currentYear = new Date().getFullYear();
  return (
    <div className="form__wrapper form__wrapper--dob">
      <select
        className={`form__input form__input--select ${
          field.showError ? "form__input--error" : ""
        } ${!field.day ? "form__input--default" : ""}`}
        value={field.day}
        name="day"
        aria-label="day"
        onChange={evt => onChange(evt.currentTarget.value, name, "day")}
      >
        <option value="" disabled>
          DD
        </option>
        {Array.apply(null, Array(31)).map((_, i) => (
          <option value={`0${i + 1}`.slice(-2)} key={`${name}_day_${i}`}>
            {`0${i + 1}`.slice(-2)}
          </option>
        ))}
      </select>

      <select
        className={`form__input form__input--select form__input--month ${
          field.showError ? "form__input--error" : ""
        } ${!field.month ? "form__input--default" : ""}`}
        value={field.month}
        name="month"
        aria-label="month"
        onChange={evt => onChange(evt.currentTarget.value, name, "month")}
      >
        <option value="" disabled>
          MM
        </option>
        {months.map((month, i) => (
          <option value={`0${i + 1}`.slice(-2)} key={`${name}_month_${i}`}>
            {month}
          </option>
        ))}
      </select>

      <select
        className={`form__input form__input--select ${
          field.showError ? "form__input--error" : ""
        } ${!field.year ? "form__input--default" : ""}`}
        value={field.year}
        name="year"
        aria-label="year"
        onChange={evt => onChange(evt.currentTarget.value, name, "year")}
      >
        <option value="" disabled>
          YYYY
        </option>
        {Array.apply(null, Array(120)).map((_, i) => (
          <option value={`${currentYear - i}`} key={`${name}_year_${i}`}>
            {currentYear - i}
          </option>
        ))}
      </select>

      {field.showError && (
        <p className="form__copy form__copy--error">{errorMessage}</p>
      )}
    </div>
  );
};

export default Dob;



// WEBPACK FOOTER //
// ./src/components/_common/Form/inputs/Dob.js